import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';
import styles from './styles.scss';

import { getMyPoints } from '@/services/myself';

export default (props) => {
  const user = props.location.state.user;

  const [dataList, setDataList] = useState([]);

  const typeArr = ['每日打卡', '娱乐视频', '热点新闻', '心情说说', '图片故事', '猜谜语','分享','答题','观看','分享','评论','收藏','点赞','订阅'];

  const typeMap = {
    0: '',
    1: '每日打卡',
    2: '娱乐视频',
    3: '热点新闻',
    4: '心情说说',
    5: '图片故事',
    6: '猜谜语',
    7: '小程序分享',
    8: '答题',
    9: '观看',
    10: '幸福课堂分享',
    11: '评论',
    12: '收藏',
    13: '点赞',
    14: '订阅',
    15: '兑换课程',
    16: '邀请新客户',
    17: '观看幸福直播',
    18: '直播间分享',

    51: '门店消费',
    52: '推荐办卡',
    53: '推荐人消费',
    54: '完成任务',
    55: '线上购卡',

    90: '积分商城消费',
  }


  useEffect(() => {
    Toast.loading('loading',60);
    getMyPoints().then(res => {
      console.log(res);
      Toast.hide();
      if (res && res.code == 200) {
        setDataList(res.data);
      }else {
        Toast.fail('获取失败，请重试');
      }
    }).catch(e=>{
      Toast.hide();
      Toast.fail('获取失败，请重试');
    });
  }, []);


  return (
    <Page transition={true} infiniteLoader={false} ptr={false}>

      <div className={styles.header}>
        <label className={styles.labelTitle}>当前积分</label>
        <label className={styles.labelValue}>{user.power}</label>
      </div>

      <div className={styles.box}>
        <div className={styles.boxTitle}>积分简介</div>
        <div className={styles.boxDesc}>
          用户可通过在公众号完成任务获得积分，积分可以在幸福全家积分商兑换商品，不得提现和转借他人。
        </div>
      </div>

      <div className={styles.box}>
        <div className={styles.boxTitle}>收支记录 <label>最多显示20条记录</label></div>

        {dataList.map((item,i) =>(
          <div className={styles.recordItem} key={i+''}>
            <label className={styles.itemTitle}>{typeMap[item.type]}</label>
            <label className={styles.itemTime}>{item.createTime}</label>
            <label className={styles.itemValue}>{item.power >= 0 ? '+' : ''}{item.power}</label>
          </div>
        ))}

      </div>
    </Page>
  )
}
